import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal from "./Reveal";

const FAQS = [
  {
    q: "Apakah steger bisa diantar ke lokasi proyek?",
    a: "Ya. Pesanan sewa steger kami diantar langsung ke lokasi proyek sesuai area layanan.",
  },
  {
    q: "Apakah bisa sewa steger dalam jumlah banyak?",
    a: "Bisa. Hubungi kami untuk mendiskusikan jumlah dan kebutuhan proyek Anda.",
  },
  {
    q: "Apakah Mitra Bangun Utama menjual steger?",
    a: "Ya. Selain layanan sewa, kami juga melayani pembelian steger.",
  },
  {
    q: "Bagaimana cara mendapatkan harga sewa?",
    a: "Hubungi kami melalui WhatsApp dan informasikan kebutuhan serta lokasi proyek untuk mendapatkan penawaran.",
  },
  {
    q: "Apakah bisa konsultasi kebutuhan steger?",
    a: "Tentu. Tim kami siap membantu mendiskusikan kebutuhan steger untuk proyek Anda.",
  },
];

const Item = ({ faq, index, open, onToggle }) => (
  <div className="border-b border-[#E5E2DA]" data-testid={`faq-item-${index}`}>
    <button
      onClick={onToggle}
      data-testid={`faq-question-${index}`}
      aria-expanded={open}
      className="flex w-full items-center justify-between gap-6 py-6 text-left"
    >
      <span className="flex items-baseline gap-4">
        <span className="font-tech text-[10px] uppercase tracking-[0.2em] text-[#DF9F00]">
          Q{String(index + 1).padStart(2, "0")}
        </span>
        <span
          className={`font-display text-lg font-semibold tracking-normal transition-colors duration-300 sm:text-xl ${
            open ? "text-[#DF9F00]" : "text-[#141619]"
          }`}
        >
          {faq.q}
        </span>
      </span><span className="inline-block h-[2px] w-10 bg-[#DF9F00]" />
      <span
        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border transition-all duration-500 ${
          open
            ? "rotate-45 border-[#DF9F00] bg-[#DF9F00] text-white"
            : "border-[#E5E2DA] text-[#141619]"
        }`}
      >
        <Plus className="h-4 w-4" strokeWidth={2.5} />
      </span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="overflow-hidden"
        >
          <p
            data-testid={`faq-answer-${index}`}
            className="max-w-2xl pb-7 pl-12 text-sm leading-relaxed text-[#525866] sm:pl-14"
          >
            {faq.a}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-[#F7F5F0] py-20 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <p className="font-tech mb-4 flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-[#525866]">
              <span className="inline-block h-[2px] w-10 bg-[#DF9F00]" />
              FAQ
              <span className="inline-block h-[2px] w-10 bg-[#DF9F00]" />
            </p>
            <h2 className="font-display text-3xl font-semibold uppercase tracking-wide text-[#141619] sm:text-4xl">
              PERTANYAAN
              <br />
              UMUM
            </h2>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#525866]">
              Tidak menemukan jawaban? Tim kami siap membantu melalui WhatsApp.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-8">
            <div className="border-t border-[#E5E2DA]">
              {FAQS.map((faq, i) => (
                <Item
                  key={faq.q}
                  faq={faq}
                  index={i}
                  open={open === i}
                  onToggle={() => setOpen(open === i ? -1 : i)}
                />
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Faq;
